// source: external/aggregation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.external.AssetAggregation', null, global);
goog.exportSymbol('proto.external.AssetAggregationResponse', null, global);
goog.exportSymbol('proto.external.AssetKpiResponse', null, global);
goog.exportSymbol('proto.external.AssetManagerResponse', null, global);
goog.exportSymbol('proto.external.AssetManagersResponse', null, global);
goog.exportSymbol('proto.external.AssetRequest', null, global);
goog.exportSymbol('proto.external.DownloadInvoiceRequest', null, global);
goog.exportSymbol('proto.external.DownloadInvoiceResponse', null, global);
goog.exportSymbol('proto.external.ExecuteInvoiceActionRequest', null, global);
goog.exportSymbol('proto.external.ExecuteInvoiceActionResponse', null, global);
goog.exportSymbol('proto.external.GetAssetAggregationRequest', null, global);
goog.exportSymbol('proto.external.GetAssetManagersRequest', null, global);
goog.exportSymbol('proto.external.GetBreadCrumbsRequest', null, global);
goog.exportSymbol('proto.external.GetBreadCrumbsResponse', null, global);
goog.exportSymbol('proto.external.GetInvoiceSettingsRequest', null, global);
goog.exportSymbol('proto.external.GetInvoiceSettingsResponse', null, global);
goog.exportSymbol('proto.external.GetRecipientsRequest', null, global);
goog.exportSymbol('proto.external.GetRecipientsResponse', null, global);
goog.exportSymbol('proto.external.GetTenantByPortfolioIDsRequest', null, global);
goog.exportSymbol('proto.external.GetTenantByPortfolioIDsResponse', null, global);
goog.exportSymbol('proto.external.GetTenantHeaderRequest', null, global);
goog.exportSymbol('proto.external.GetTenantHeaderResponse', null, global);
goog.exportSymbol('proto.external.GetTenantInvoicesRequest', null, global);
goog.exportSymbol('proto.external.GetTenantInvoicesResponse', null, global);
goog.exportSymbol('proto.external.GetTenantsInvoicesRequest', null, global);
goog.exportSymbol('proto.external.GetTenantsInvoicesResponse', null, global);
goog.exportSymbol('proto.external.GetTotalsByTypesRequest', null, global);
goog.exportSymbol('proto.external.GetTotalsByTypesResponse', null, global);
goog.exportSymbol('proto.external.InvoiceAction', null, global);
goog.exportSymbol('proto.external.InvoiceDetailsResponse', null, global);
goog.exportSymbol('proto.external.InvoiceSettings', null, global);
goog.exportSymbol('proto.external.PortfolioAggregation', null, global);
goog.exportSymbol('proto.external.PortfoliosAggregationResponse', null, global);
goog.exportSymbol('proto.external.SaveInvoiceSettingsRequest', null, global);
goog.exportSymbol('proto.external.SaveInvoiceSettingsResponse', null, global);
goog.exportSymbol('proto.external.SyncRecipientsRequest', null, global);
goog.exportSymbol('proto.external.SyncRecipientsResponse', null, global);
goog.exportSymbol('proto.external.TenantInvoiceResponse', null, global);
goog.exportSymbol('proto.external.TenantResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.AssetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.AssetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.AssetRequest.displayName = 'proto.external.AssetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.AssetKpiResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.AssetKpiResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.AssetKpiResponse.displayName = 'proto.external.AssetKpiResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTenantByPortfolioIDsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetTenantByPortfolioIDsRequest.repeatedFields_, null);
};
goog.inherits(proto.external.GetTenantByPortfolioIDsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTenantByPortfolioIDsRequest.displayName = 'proto.external.GetTenantByPortfolioIDsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTenantByPortfolioIDsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetTenantByPortfolioIDsResponse.repeatedFields_, null);
};
goog.inherits(proto.external.GetTenantByPortfolioIDsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTenantByPortfolioIDsResponse.displayName = 'proto.external.GetTenantByPortfolioIDsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.TenantResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.TenantResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.TenantResponse.displayName = 'proto.external.TenantResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTenantHeaderRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetTenantHeaderRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTenantHeaderRequest.displayName = 'proto.external.GetTenantHeaderRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTenantHeaderResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetTenantHeaderResponse.repeatedFields_, null);
};
goog.inherits(proto.external.GetTenantHeaderResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTenantHeaderResponse.displayName = 'proto.external.GetTenantHeaderResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetBreadCrumbsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetBreadCrumbsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetBreadCrumbsRequest.displayName = 'proto.external.GetBreadCrumbsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetBreadCrumbsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetBreadCrumbsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetBreadCrumbsResponse.displayName = 'proto.external.GetBreadCrumbsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetAssetAggregationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetAssetAggregationRequest.repeatedFields_, null);
};
goog.inherits(proto.external.GetAssetAggregationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetAssetAggregationRequest.displayName = 'proto.external.GetAssetAggregationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.AssetAggregationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.AssetAggregationResponse.repeatedFields_, null);
};
goog.inherits(proto.external.AssetAggregationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.AssetAggregationResponse.displayName = 'proto.external.AssetAggregationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.AssetAggregation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.AssetAggregation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.AssetAggregation.displayName = 'proto.external.AssetAggregation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.PortfoliosAggregationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.PortfoliosAggregationResponse.repeatedFields_, null);
};
goog.inherits(proto.external.PortfoliosAggregationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.PortfoliosAggregationResponse.displayName = 'proto.external.PortfoliosAggregationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.PortfolioAggregation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.PortfolioAggregation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.PortfolioAggregation.displayName = 'proto.external.PortfolioAggregation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTotalsByTypesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetTotalsByTypesRequest.repeatedFields_, null);
};
goog.inherits(proto.external.GetTotalsByTypesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTotalsByTypesRequest.displayName = 'proto.external.GetTotalsByTypesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTotalsByTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetTotalsByTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTotalsByTypesResponse.displayName = 'proto.external.GetTotalsByTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetAssetManagersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetAssetManagersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetAssetManagersRequest.displayName = 'proto.external.GetAssetManagersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.AssetManagersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.AssetManagersResponse.repeatedFields_, null);
};
goog.inherits(proto.external.AssetManagersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.AssetManagersResponse.displayName = 'proto.external.AssetManagersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.AssetManagerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.AssetManagerResponse.repeatedFields_, null);
};
goog.inherits(proto.external.AssetManagerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.AssetManagerResponse.displayName = 'proto.external.AssetManagerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTenantsInvoicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetTenantsInvoicesRequest.repeatedFields_, null);
};
goog.inherits(proto.external.GetTenantsInvoicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTenantsInvoicesRequest.displayName = 'proto.external.GetTenantsInvoicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTenantsInvoicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetTenantsInvoicesResponse.repeatedFields_, null);
};
goog.inherits(proto.external.GetTenantsInvoicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTenantsInvoicesResponse.displayName = 'proto.external.GetTenantsInvoicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.TenantInvoiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.TenantInvoiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.TenantInvoiceResponse.displayName = 'proto.external.TenantInvoiceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTenantInvoicesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetTenantInvoicesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTenantInvoicesRequest.displayName = 'proto.external.GetTenantInvoicesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetTenantInvoicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetTenantInvoicesResponse.repeatedFields_, null);
};
goog.inherits(proto.external.GetTenantInvoicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetTenantInvoicesResponse.displayName = 'proto.external.GetTenantInvoicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.InvoiceDetailsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.InvoiceDetailsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.InvoiceDetailsResponse.displayName = 'proto.external.InvoiceDetailsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.ExecuteInvoiceActionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.ExecuteInvoiceActionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.ExecuteInvoiceActionRequest.displayName = 'proto.external.ExecuteInvoiceActionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.ExecuteInvoiceActionResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.ExecuteInvoiceActionResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.ExecuteInvoiceActionResponse.displayName = 'proto.external.ExecuteInvoiceActionResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetRecipientsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetRecipientsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetRecipientsRequest.displayName = 'proto.external.GetRecipientsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetRecipientsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.GetRecipientsResponse.repeatedFields_, null);
};
goog.inherits(proto.external.GetRecipientsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetRecipientsResponse.displayName = 'proto.external.GetRecipientsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.SyncRecipientsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.SyncRecipientsRequest.repeatedFields_, null);
};
goog.inherits(proto.external.SyncRecipientsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.SyncRecipientsRequest.displayName = 'proto.external.SyncRecipientsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.SyncRecipientsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.external.SyncRecipientsResponse.repeatedFields_, null);
};
goog.inherits(proto.external.SyncRecipientsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.SyncRecipientsResponse.displayName = 'proto.external.SyncRecipientsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.InvoiceSettings = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.InvoiceSettings, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.InvoiceSettings.displayName = 'proto.external.InvoiceSettings';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.SaveInvoiceSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.SaveInvoiceSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.SaveInvoiceSettingsRequest.displayName = 'proto.external.SaveInvoiceSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.SaveInvoiceSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.SaveInvoiceSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.SaveInvoiceSettingsResponse.displayName = 'proto.external.SaveInvoiceSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetInvoiceSettingsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetInvoiceSettingsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetInvoiceSettingsRequest.displayName = 'proto.external.GetInvoiceSettingsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.GetInvoiceSettingsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.GetInvoiceSettingsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.GetInvoiceSettingsResponse.displayName = 'proto.external.GetInvoiceSettingsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.DownloadInvoiceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.DownloadInvoiceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.DownloadInvoiceRequest.displayName = 'proto.external.DownloadInvoiceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.external.DownloadInvoiceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.external.DownloadInvoiceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.external.DownloadInvoiceResponse.displayName = 'proto.external.DownloadInvoiceResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.AssetRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.AssetRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.AssetRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.AssetRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      assetid: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.AssetRequest}
 */
proto.external.AssetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.AssetRequest;
  return proto.external.AssetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.AssetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.AssetRequest}
 */
proto.external.AssetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.AssetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.AssetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.AssetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.AssetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string assetID = 1;
 * @return {string}
 */
proto.external.AssetRequest.prototype.getAssetid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetRequest} returns this
 */
proto.external.AssetRequest.prototype.setAssetid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.AssetKpiResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.AssetKpiResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.AssetKpiResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.AssetKpiResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantcount: jspb.Message.getFieldWithDefault(msg, 1, 0),
      unitcount: jspb.Message.getFieldWithDefault(msg, 2, 0),
      occupancyrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
      leasedarea: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
      monthlyrent: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
      annualnoi: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
      valuation: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
      footfall: jspb.Message.getFieldWithDefault(msg, 8, 0),
      totalgla: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
      valuationdate: jspb.Message.getFieldWithDefault(msg, 10, 0),
      totalgba: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
      totalplotarea: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.AssetKpiResponse}
 */
proto.external.AssetKpiResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.AssetKpiResponse;
  return proto.external.AssetKpiResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.AssetKpiResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.AssetKpiResponse}
 */
proto.external.AssetKpiResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTenantcount(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUnitcount(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setOccupancyrate(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setLeasedarea(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setMonthlyrent(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setAnnualnoi(value);
        break;
      case 7:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setValuation(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setFootfall(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalgla(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setValuationdate(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalgba(value);
        break;
      case 12:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setTotalplotarea(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.AssetKpiResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.AssetKpiResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.AssetKpiResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.AssetKpiResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantcount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getUnitcount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getOccupancyrate();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getLeasedarea();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getMonthlyrent();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getAnnualnoi();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getValuation();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getFootfall();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getTotalgla();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getValuationdate();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getTotalgba();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getTotalplotarea();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
};


/**
 * optional int32 tenantCount = 1;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getTenantcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setTenantcount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 unitCount = 2;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getUnitcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setUnitcount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional double occupancyRate = 3;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getOccupancyrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setOccupancyrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double leasedArea = 4;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getLeasedarea = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setLeasedarea = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double monthlyRent = 5;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getMonthlyrent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setMonthlyrent = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double annualNOI = 6;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getAnnualnoi = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setAnnualnoi = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double valuation = 7;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getValuation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setValuation = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional int32 footfall = 8;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getFootfall = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setFootfall = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional double totalGLA = 9;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getTotalgla = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setTotalgla = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional int64 valuationDate = 10;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getValuationdate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setValuationdate = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional double totalGBA = 11;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getTotalgba = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setTotalgba = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double totalPlotArea = 12;
 * @return {number}
 */
proto.external.AssetKpiResponse.prototype.getTotalplotarea = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetKpiResponse} returns this
 */
proto.external.AssetKpiResponse.prototype.setTotalplotarea = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetTenantByPortfolioIDsRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTenantByPortfolioIDsRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTenantByPortfolioIDsRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTenantByPortfolioIDsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTenantByPortfolioIDsRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      portfoliosList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
      assetsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTenantByPortfolioIDsRequest}
 */
proto.external.GetTenantByPortfolioIDsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTenantByPortfolioIDsRequest;
  return proto.external.GetTenantByPortfolioIDsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTenantByPortfolioIDsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTenantByPortfolioIDsRequest}
 */
proto.external.GetTenantByPortfolioIDsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.addPortfolios(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.addAssets(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTenantByPortfolioIDsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTenantByPortfolioIDsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTenantByPortfolioIDsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortfoliosList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string portfolios = 1;
 * @return {!Array<string>}
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.getPortfoliosList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetTenantByPortfolioIDsRequest} returns this
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.setPortfoliosList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetTenantByPortfolioIDsRequest} returns this
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.addPortfolios = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantByPortfolioIDsRequest} returns this
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.clearPortfoliosList = function() {
  return this.setPortfoliosList([]);
};


/**
 * repeated string assets = 2;
 * @return {!Array<string>}
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.getAssetsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetTenantByPortfolioIDsRequest} returns this
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.setAssetsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetTenantByPortfolioIDsRequest} returns this
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.addAssets = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantByPortfolioIDsRequest} returns this
 */
proto.external.GetTenantByPortfolioIDsRequest.prototype.clearAssetsList = function() {
  return this.setAssetsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetTenantByPortfolioIDsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTenantByPortfolioIDsResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTenantByPortfolioIDsResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTenantByPortfolioIDsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTenantByPortfolioIDsResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantsList: jspb.Message.toObjectList(msg.getTenantsList(),
        proto.external.TenantResponse.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTenantByPortfolioIDsResponse}
 */
proto.external.GetTenantByPortfolioIDsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTenantByPortfolioIDsResponse;
  return proto.external.GetTenantByPortfolioIDsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTenantByPortfolioIDsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTenantByPortfolioIDsResponse}
 */
proto.external.GetTenantByPortfolioIDsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.external.TenantResponse;
        reader.readMessage(value,proto.external.TenantResponse.deserializeBinaryFromReader);
        msg.addTenants(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTenantByPortfolioIDsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTenantByPortfolioIDsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTenantByPortfolioIDsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTenantByPortfolioIDsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.external.TenantResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TenantResponse tenants = 1;
 * @return {!Array<!proto.external.TenantResponse>}
 */
proto.external.GetTenantByPortfolioIDsResponse.prototype.getTenantsList = function() {
  return /** @type{!Array<!proto.external.TenantResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.external.TenantResponse, 1));
};


/**
 * @param {!Array<!proto.external.TenantResponse>} value
 * @return {!proto.external.GetTenantByPortfolioIDsResponse} returns this
 */
proto.external.GetTenantByPortfolioIDsResponse.prototype.setTenantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.external.TenantResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.external.TenantResponse}
 */
proto.external.GetTenantByPortfolioIDsResponse.prototype.addTenants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.external.TenantResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantByPortfolioIDsResponse} returns this
 */
proto.external.GetTenantByPortfolioIDsResponse.prototype.clearTenantsList = function() {
  return this.setTenantsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.TenantResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.TenantResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.TenantResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.TenantResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      companyname: jspb.Message.getFieldWithDefault(msg, 1, ""),
      tradingname: jspb.Message.getFieldWithDefault(msg, 2, ""),
      industry: jspb.Message.getFieldWithDefault(msg, 3, ""),
      country: jspb.Message.getFieldWithDefault(msg, 4, ""),
      city: jspb.Message.getFieldWithDefault(msg, 5, ""),
      street: jspb.Message.getFieldWithDefault(msg, 6, ""),
      postcode: jspb.Message.getFieldWithDefault(msg, 7, ""),
      assetid: jspb.Message.getFieldWithDefault(msg, 8, ""),
      id: jspb.Message.getFieldWithDefault(msg, 9, ""),
      inplace: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
      contractstartdate: jspb.Message.getFieldWithDefault(msg, 11, ""),
      contractenddate: jspb.Message.getFieldWithDefault(msg, 12, ""),
      assetname: jspb.Message.getFieldWithDefault(msg, 13, ""),
      totalgla: jspb.Message.getFieldWithDefault(msg, 14, 0),
      totalrent: jspb.Message.getFieldWithDefault(msg, 15, 0),
      headOfficeAddress: jspb.Message.getFieldWithDefault(msg, 16, ""),
      notes: jspb.Message.getFieldWithDefault(msg, 17, ""),
      mainContact: jspb.Message.getFieldWithDefault(msg, 18, ""),
      position: jspb.Message.getFieldWithDefault(msg, 19, ""),
      email: jspb.Message.getFieldWithDefault(msg, 20, ""),
      phone: jspb.Message.getFieldWithDefault(msg, 21, ""),
      indexationdate: jspb.Message.getFieldWithDefault(msg, 22, ""),
      indexation: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
      comment: jspb.Message.getFieldWithDefault(msg, 24, ""),
      portfolioname: jspb.Message.getFieldWithDefault(msg, 25, ""),
      monthlyrent: jspb.Message.getFieldWithDefault(msg, 26, 0),
      breakcount: jspb.Message.getFieldWithDefault(msg, 27, 0),
      otherclausescount: jspb.Message.getFieldWithDefault(msg, 28, 0),
      guaranteedepositscount: jspb.Message.getFieldWithDefault(msg, 29, 0),
      guaranteebanklettercount: jspb.Message.getFieldWithDefault(msg, 30, 0),
      assetstatus: jspb.Message.getFieldWithDefault(msg, 31, ""),
      portfolioid: jspb.Message.getFieldWithDefault(msg, 32, ""),
      assettype: jspb.Message.getFieldWithDefault(msg, 33, ""),
      assetmanager: jspb.Message.getFieldWithDefault(msg, 35, ""),
      gcpi: jspb.Message.getBooleanFieldWithDefault(msg, 36, false),
      currentmonthlyrent: jspb.Message.getFieldWithDefault(msg, 37, 0),
      rentpersqm: jspb.Message.getFloatingPointFieldWithDefault(msg, 38, 0.0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.TenantResponse}
 */
proto.external.TenantResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.TenantResponse;
  return proto.external.TenantResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.TenantResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.TenantResponse}
 */
proto.external.TenantResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyname(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setTradingname(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setIndustry(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCountry(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStreet(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setPostcode(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetid(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      case 10:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setInplace(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setContractstartdate(value);
        break;
      case 12:
        var value = /** @type {string} */ (reader.readString());
        msg.setContractenddate(value);
        break;
      case 13:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetname(value);
        break;
      case 14:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotalgla(value);
        break;
      case 15:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotalrent(value);
        break;
      case 16:
        var value = /** @type {string} */ (reader.readString());
        msg.setHeadOfficeAddress(value);
        break;
      case 17:
        var value = /** @type {string} */ (reader.readString());
        msg.setNotes(value);
        break;
      case 18:
        var value = /** @type {string} */ (reader.readString());
        msg.setMainContact(value);
        break;
      case 19:
        var value = /** @type {string} */ (reader.readString());
        msg.setPosition(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setEmail(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setPhone(value);
        break;
      case 22:
        var value = /** @type {string} */ (reader.readString());
        msg.setIndexationdate(value);
        break;
      case 23:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setIndexation(value);
        break;
      case 24:
        var value = /** @type {string} */ (reader.readString());
        msg.setComment(value);
        break;
      case 25:
        var value = /** @type {string} */ (reader.readString());
        msg.setPortfolioname(value);
        break;
      case 26:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setMonthlyrent(value);
        break;
      case 27:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setBreakcount(value);
        break;
      case 28:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setOtherclausescount(value);
        break;
      case 29:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setGuaranteedepositscount(value);
        break;
      case 30:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setGuaranteebanklettercount(value);
        break;
      case 31:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetstatus(value);
        break;
      case 32:
        var value = /** @type {string} */ (reader.readString());
        msg.setPortfolioid(value);
        break;
      case 33:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssettype(value);
        break;
      case 35:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetmanager(value);
        break;
      case 36:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setGcpi(value);
        break;
      case 37:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setCurrentmonthlyrent(value);
        break;
      case 38:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setRentpersqm(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.TenantResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.TenantResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.TenantResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.TenantResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTradingname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIndustry();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getPostcode();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAssetid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getInplace();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getContractstartdate();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getContractenddate();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAssetname();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTotalgla();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getTotalrent();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getHeadOfficeAddress();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getNotes();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getMainContact();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getPosition();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getIndexationdate();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getIndexation();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getPortfolioname();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getMonthlyrent();
  if (f !== 0) {
    writer.writeInt32(
      26,
      f
    );
  }
  f = message.getBreakcount();
  if (f !== 0) {
    writer.writeInt32(
      27,
      f
    );
  }
  f = message.getOtherclausescount();
  if (f !== 0) {
    writer.writeInt32(
      28,
      f
    );
  }
  f = message.getGuaranteedepositscount();
  if (f !== 0) {
    writer.writeInt32(
      29,
      f
    );
  }
  f = message.getGuaranteebanklettercount();
  if (f !== 0) {
    writer.writeInt32(
      30,
      f
    );
  }
  f = message.getAssetstatus();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getPortfolioid();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getAssettype();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getAssetmanager();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getGcpi();
  if (f) {
    writer.writeBool(
      36,
      f
    );
  }
  f = message.getCurrentmonthlyrent();
  if (f !== 0) {
    writer.writeInt32(
      37,
      f
    );
  }
  f = message.getRentpersqm();
  if (f !== 0.0) {
    writer.writeDouble(
      38,
      f
    );
  }
};


/**
 * optional string companyName = 1;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getCompanyname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setCompanyname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tradingName = 2;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getTradingname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setTradingname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string industry = 3;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getIndustry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setIndustry = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string country = 4;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string city = 5;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string street = 6;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string postcode = 7;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getPostcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setPostcode = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string assetID = 8;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getAssetid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setAssetid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string id = 9;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool inPlace = 10;
 * @return {boolean}
 */
proto.external.TenantResponse.prototype.getInplace = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setInplace = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string contractStartDate = 11;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getContractstartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setContractstartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string contractEndDate = 12;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getContractenddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setContractenddate = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string assetName = 13;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getAssetname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setAssetname = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 totalGLA = 14;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getTotalgla = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setTotalgla = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 totalRent = 15;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getTotalrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setTotalrent = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional string head_office_address = 16;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getHeadOfficeAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setHeadOfficeAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string notes = 17;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string main_contact = 18;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getMainContact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setMainContact = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string position = 19;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getPosition = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setPosition = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string email = 20;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string phone = 21;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string indexationDate = 22;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getIndexationdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setIndexationdate = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional double indexation = 23;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getIndexation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setIndexation = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional string comment = 24;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string portfolioName = 25;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getPortfolioname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setPortfolioname = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional int32 monthlyRent = 26;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getMonthlyrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setMonthlyrent = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int32 breakCount = 27;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getBreakcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setBreakcount = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * optional int32 otherClausesCount = 28;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getOtherclausescount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setOtherclausescount = function(value) {
  return jspb.Message.setProto3IntField(this, 28, value);
};


/**
 * optional int32 guaranteeDepositsCount = 29;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getGuaranteedepositscount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setGuaranteedepositscount = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional int32 guaranteeBankLetterCount = 30;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getGuaranteebanklettercount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setGuaranteebanklettercount = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional string assetStatus = 31;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getAssetstatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setAssetstatus = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string portfolioId = 32;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getPortfolioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setPortfolioid = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string assetType = 33;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getAssettype = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setAssettype = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string assetManager = 35;
 * @return {string}
 */
proto.external.TenantResponse.prototype.getAssetmanager = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setAssetmanager = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional bool gcpi = 36;
 * @return {boolean}
 */
proto.external.TenantResponse.prototype.getGcpi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 36, false));
};


/**
 * @param {boolean} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setGcpi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 36, value);
};


/**
 * optional int32 currentMonthlyRent = 37;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getCurrentmonthlyrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setCurrentmonthlyrent = function(value) {
  return jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * optional double rentPerSqm = 38;
 * @return {number}
 */
proto.external.TenantResponse.prototype.getRentpersqm = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 38, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantResponse} returns this
 */
proto.external.TenantResponse.prototype.setRentpersqm = function(value) {
  return jspb.Message.setProto3FloatField(this, 38, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTenantHeaderRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTenantHeaderRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTenantHeaderRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTenantHeaderRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantid: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTenantHeaderRequest}
 */
proto.external.GetTenantHeaderRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTenantHeaderRequest;
  return proto.external.GetTenantHeaderRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTenantHeaderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTenantHeaderRequest}
 */
proto.external.GetTenantHeaderRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTenantid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTenantHeaderRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTenantHeaderRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTenantHeaderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTenantHeaderRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tenantID = 1;
 * @return {string}
 */
proto.external.GetTenantHeaderRequest.prototype.getTenantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetTenantHeaderRequest} returns this
 */
proto.external.GetTenantHeaderRequest.prototype.setTenantid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetTenantHeaderResponse.repeatedFields_ = [2,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTenantHeaderResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTenantHeaderResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTenantHeaderResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTenantHeaderResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      companyname: jspb.Message.getFieldWithDefault(msg, 1, ""),
      unitnamesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
      totalgla: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
      floorsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
      assetid: jspb.Message.getFieldWithDefault(msg, 5, ""),
      contractstartdate: jspb.Message.getFieldWithDefault(msg, 6, ""),
      contractenddate: jspb.Message.getFieldWithDefault(msg, 7, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTenantHeaderResponse}
 */
proto.external.GetTenantHeaderResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTenantHeaderResponse;
  return proto.external.GetTenantHeaderResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTenantHeaderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTenantHeaderResponse}
 */
proto.external.GetTenantHeaderResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyname(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.addUnitnames(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setTotalgla(value);
        break;
      case 4:
        var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt32() : [reader.readInt32()]);
        for (var i = 0; i < values.length; i++) {
          msg.addFloors(values[i]);
        }
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetid(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setContractstartdate(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setContractenddate(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTenantHeaderResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTenantHeaderResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTenantHeaderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTenantHeaderResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnitnamesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getTotalgla();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getFloorsList();
  if (f.length > 0) {
    writer.writePackedInt32(
      4,
      f
    );
  }
  f = message.getAssetid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getContractstartdate();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getContractenddate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string companyName = 1;
 * @return {string}
 */
proto.external.GetTenantHeaderResponse.prototype.getCompanyname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.setCompanyname = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string unitNames = 2;
 * @return {!Array<string>}
 */
proto.external.GetTenantHeaderResponse.prototype.getUnitnamesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.setUnitnamesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.addUnitnames = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.clearUnitnamesList = function() {
  return this.setUnitnamesList([]);
};


/**
 * optional float totalGLA = 3;
 * @return {number}
 */
proto.external.GetTenantHeaderResponse.prototype.getTotalgla = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.setTotalgla = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * repeated int32 floors = 4;
 * @return {!Array<number>}
 */
proto.external.GetTenantHeaderResponse.prototype.getFloorsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.setFloorsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.addFloors = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.clearFloorsList = function() {
  return this.setFloorsList([]);
};


/**
 * optional string assetID = 5;
 * @return {string}
 */
proto.external.GetTenantHeaderResponse.prototype.getAssetid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.setAssetid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string contractStartDate = 6;
 * @return {string}
 */
proto.external.GetTenantHeaderResponse.prototype.getContractstartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.setContractstartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string contractEndDate = 7;
 * @return {string}
 */
proto.external.GetTenantHeaderResponse.prototype.getContractenddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetTenantHeaderResponse} returns this
 */
proto.external.GetTenantHeaderResponse.prototype.setContractenddate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetBreadCrumbsRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetBreadCrumbsRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetBreadCrumbsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetBreadCrumbsRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantid: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetBreadCrumbsRequest}
 */
proto.external.GetBreadCrumbsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetBreadCrumbsRequest;
  return proto.external.GetBreadCrumbsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetBreadCrumbsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetBreadCrumbsRequest}
 */
proto.external.GetBreadCrumbsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTenantid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetBreadCrumbsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetBreadCrumbsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetBreadCrumbsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetBreadCrumbsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tenantID = 1;
 * @return {string}
 */
proto.external.GetBreadCrumbsRequest.prototype.getTenantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetBreadCrumbsRequest} returns this
 */
proto.external.GetBreadCrumbsRequest.prototype.setTenantid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetBreadCrumbsResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetBreadCrumbsResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetBreadCrumbsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetBreadCrumbsResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantid: jspb.Message.getFieldWithDefault(msg, 1, ""),
      tenantname: jspb.Message.getFieldWithDefault(msg, 2, ""),
      assetid: jspb.Message.getFieldWithDefault(msg, 3, ""),
      assetname: jspb.Message.getFieldWithDefault(msg, 4, ""),
      portfolioid: jspb.Message.getFieldWithDefault(msg, 5, ""),
      portfolioname: jspb.Message.getFieldWithDefault(msg, 6, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetBreadCrumbsResponse}
 */
proto.external.GetBreadCrumbsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetBreadCrumbsResponse;
  return proto.external.GetBreadCrumbsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetBreadCrumbsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetBreadCrumbsResponse}
 */
proto.external.GetBreadCrumbsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTenantid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setTenantname(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetid(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetname(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setPortfolioid(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setPortfolioname(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetBreadCrumbsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetBreadCrumbsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetBreadCrumbsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetBreadCrumbsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTenantname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAssetid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssetname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPortfolioid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPortfolioname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string tenantID = 1;
 * @return {string}
 */
proto.external.GetBreadCrumbsResponse.prototype.getTenantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetBreadCrumbsResponse} returns this
 */
proto.external.GetBreadCrumbsResponse.prototype.setTenantid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tenantName = 2;
 * @return {string}
 */
proto.external.GetBreadCrumbsResponse.prototype.getTenantname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetBreadCrumbsResponse} returns this
 */
proto.external.GetBreadCrumbsResponse.prototype.setTenantname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string assetID = 3;
 * @return {string}
 */
proto.external.GetBreadCrumbsResponse.prototype.getAssetid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetBreadCrumbsResponse} returns this
 */
proto.external.GetBreadCrumbsResponse.prototype.setAssetid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string assetName = 4;
 * @return {string}
 */
proto.external.GetBreadCrumbsResponse.prototype.getAssetname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetBreadCrumbsResponse} returns this
 */
proto.external.GetBreadCrumbsResponse.prototype.setAssetname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string portfolioID = 5;
 * @return {string}
 */
proto.external.GetBreadCrumbsResponse.prototype.getPortfolioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetBreadCrumbsResponse} returns this
 */
proto.external.GetBreadCrumbsResponse.prototype.setPortfolioid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string portfolioName = 6;
 * @return {string}
 */
proto.external.GetBreadCrumbsResponse.prototype.getPortfolioname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetBreadCrumbsResponse} returns this
 */
proto.external.GetBreadCrumbsResponse.prototype.setPortfolioname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetAssetAggregationRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetAssetAggregationRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetAssetAggregationRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetAssetAggregationRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetAssetAggregationRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      portfolioidsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetAssetAggregationRequest}
 */
proto.external.GetAssetAggregationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetAssetAggregationRequest;
  return proto.external.GetAssetAggregationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetAssetAggregationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetAssetAggregationRequest}
 */
proto.external.GetAssetAggregationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.addPortfolioids(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetAssetAggregationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetAssetAggregationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetAssetAggregationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetAssetAggregationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortfolioidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string portfolioIDs = 1;
 * @return {!Array<string>}
 */
proto.external.GetAssetAggregationRequest.prototype.getPortfolioidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetAssetAggregationRequest} returns this
 */
proto.external.GetAssetAggregationRequest.prototype.setPortfolioidsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetAssetAggregationRequest} returns this
 */
proto.external.GetAssetAggregationRequest.prototype.addPortfolioids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetAssetAggregationRequest} returns this
 */
proto.external.GetAssetAggregationRequest.prototype.clearPortfolioidsList = function() {
  return this.setPortfolioidsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.AssetAggregationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.AssetAggregationResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.AssetAggregationResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.AssetAggregationResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.AssetAggregationResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      assetsList: jspb.Message.toObjectList(msg.getAssetsList(),
        proto.external.AssetAggregation.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.AssetAggregationResponse}
 */
proto.external.AssetAggregationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.AssetAggregationResponse;
  return proto.external.AssetAggregationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.AssetAggregationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.AssetAggregationResponse}
 */
proto.external.AssetAggregationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.external.AssetAggregation;
        reader.readMessage(value,proto.external.AssetAggregation.deserializeBinaryFromReader);
        msg.addAssets(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.AssetAggregationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.AssetAggregationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.AssetAggregationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.AssetAggregationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.external.AssetAggregation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AssetAggregation assets = 1;
 * @return {!Array<!proto.external.AssetAggregation>}
 */
proto.external.AssetAggregationResponse.prototype.getAssetsList = function() {
  return /** @type{!Array<!proto.external.AssetAggregation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.external.AssetAggregation, 1));
};


/**
 * @param {!Array<!proto.external.AssetAggregation>} value
 * @return {!proto.external.AssetAggregationResponse} returns this
 */
proto.external.AssetAggregationResponse.prototype.setAssetsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.external.AssetAggregation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.external.AssetAggregation}
 */
proto.external.AssetAggregationResponse.prototype.addAssets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.external.AssetAggregation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.AssetAggregationResponse} returns this
 */
proto.external.AssetAggregationResponse.prototype.clearAssetsList = function() {
  return this.setAssetsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.AssetAggregation.prototype.toObject = function(opt_includeInstance) {
    return proto.external.AssetAggregation.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.AssetAggregation} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.AssetAggregation.toObject = function(includeInstance, msg) {
    var f, obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      country: jspb.Message.getFieldWithDefault(msg, 3, ""),
      city: jspb.Message.getFieldWithDefault(msg, 4, ""),
      street: jspb.Message.getFieldWithDefault(msg, 5, ""),
      postcode: jspb.Message.getFieldWithDefault(msg, 6, ""),
      type: jspb.Message.getFieldWithDefault(msg, 7, ""),
      portfolioid: jspb.Message.getFieldWithDefault(msg, 8, ""),
      portfolioname: jspb.Message.getFieldWithDefault(msg, 9, ""),
      tenantcount: jspb.Message.getFieldWithDefault(msg, 10, 0),
      occupancy: jspb.Message.getFieldWithDefault(msg, 11, 0),
      glatotal: jspb.Message.getFieldWithDefault(msg, 12, 0),
      alertcount: jspb.Message.getFieldWithDefault(msg, 13, 0),
      lastvaluation: jspb.Message.getFieldWithDefault(msg, 14, 0),
      noi: jspb.Message.getFieldWithDefault(msg, 15, 0),
      yield: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
      avgrentpersqm: jspb.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
      grossyield: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
      totalrent: jspb.Message.getFieldWithDefault(msg, 19, 0),
      comment: jspb.Message.getFieldWithDefault(msg, 20, ""),
      manager: jspb.Message.getFieldWithDefault(msg, 21, ""),
      l1valuation: jspb.Message.getFloatingPointFieldWithDefault(msg, 22, 0.0),
      l1liquidationvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
      l1valuer: jspb.Message.getFieldWithDefault(msg, 24, ""),
      l1dcfmethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
      l1comparativemethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 26, 0.0),
      l1insurancemethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
      l1currentrent: jspb.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
      l1erv: jspb.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
      l1discountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 30, 0.0),
      l1exityield: jspb.Message.getFloatingPointFieldWithDefault(msg, 31, 0.0),
      status: jspb.Message.getFieldWithDefault(msg, 32, ""),
      l2valuation: jspb.Message.getFloatingPointFieldWithDefault(msg, 33, 0.0),
      l2liquidationvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 34, 0.0),
      l2valuer: jspb.Message.getFieldWithDefault(msg, 35, ""),
      l2dcfmethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 36, 0.0),
      l2comparativemethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 37, 0.0),
      l2insurancemethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 38, 0.0),
      l2currentrent: jspb.Message.getFloatingPointFieldWithDefault(msg, 39, 0.0),
      l2erv: jspb.Message.getFloatingPointFieldWithDefault(msg, 40, 0.0),
      l2discountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 41, 0.0),
      l2exityield: jspb.Message.getFloatingPointFieldWithDefault(msg, 42, 0.0),
      l3valuation: jspb.Message.getFloatingPointFieldWithDefault(msg, 43, 0.0),
      l3liquidationvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 44, 0.0),
      l3valuer: jspb.Message.getFieldWithDefault(msg, 45, ""),
      l3dcfmethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 46, 0.0),
      l3comparativemethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 47, 0.0),
      l3insurancemethodvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 48, 0.0),
      l3currentrent: jspb.Message.getFloatingPointFieldWithDefault(msg, 49, 0.0),
      l3erv: jspb.Message.getFloatingPointFieldWithDefault(msg, 50, 0.0),
      l3discountrate: jspb.Message.getFloatingPointFieldWithDefault(msg, 51, 0.0),
      l3exityield: jspb.Message.getFloatingPointFieldWithDefault(msg, 52, 0.0),
      acquisition: jspb.Message.getFloatingPointFieldWithDefault(msg, 53, 0.0),
      clientAssetId: jspb.Message.getFieldWithDefault(msg, 54, ""),
      profitCenter: jspb.Message.getFieldWithDefault(msg, 55, ""),
      costCenter: jspb.Message.getFieldWithDefault(msg, 56, ""),
      monthlyrent: jspb.Message.getFieldWithDefault(msg, 57, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.AssetAggregation}
 */
proto.external.AssetAggregation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.AssetAggregation;
  return proto.external.AssetAggregation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.AssetAggregation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.AssetAggregation}
 */
proto.external.AssetAggregation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCountry(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setCity(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setStreet(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setPostcode(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setType(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setPortfolioid(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setPortfolioname(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTenantcount(value);
        break;
      case 11:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setOccupancy(value);
        break;
      case 12:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setGlatotal(value);
        break;
      case 13:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setAlertcount(value);
        break;
      case 14:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setLastvaluation(value);
        break;
      case 15:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setNoi(value);
        break;
      case 16:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setYield(value);
        break;
      case 17:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setAvgrentpersqm(value);
        break;
      case 18:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setGrossyield(value);
        break;
      case 19:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTotalrent(value);
        break;
      case 20:
        var value = /** @type {string} */ (reader.readString());
        msg.setComment(value);
        break;
      case 21:
        var value = /** @type {string} */ (reader.readString());
        msg.setManager(value);
        break;
      case 22:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1valuation(value);
        break;
      case 23:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1liquidationvalue(value);
        break;
      case 24:
        var value = /** @type {string} */ (reader.readString());
        msg.setL1valuer(value);
        break;
      case 25:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1dcfmethodvalue(value);
        break;
      case 26:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1comparativemethodvalue(value);
        break;
      case 27:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1insurancemethodvalue(value);
        break;
      case 28:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1currentrent(value);
        break;
      case 29:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1erv(value);
        break;
      case 30:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1discountrate(value);
        break;
      case 31:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL1exityield(value);
        break;
      case 32:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      case 33:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2valuation(value);
        break;
      case 34:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2liquidationvalue(value);
        break;
      case 35:
        var value = /** @type {string} */ (reader.readString());
        msg.setL2valuer(value);
        break;
      case 36:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2dcfmethodvalue(value);
        break;
      case 37:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2comparativemethodvalue(value);
        break;
      case 38:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2insurancemethodvalue(value);
        break;
      case 39:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2currentrent(value);
        break;
      case 40:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2erv(value);
        break;
      case 41:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2discountrate(value);
        break;
      case 42:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL2exityield(value);
        break;
      case 43:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3valuation(value);
        break;
      case 44:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3liquidationvalue(value);
        break;
      case 45:
        var value = /** @type {string} */ (reader.readString());
        msg.setL3valuer(value);
        break;
      case 46:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3dcfmethodvalue(value);
        break;
      case 47:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3comparativemethodvalue(value);
        break;
      case 48:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3insurancemethodvalue(value);
        break;
      case 49:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3currentrent(value);
        break;
      case 50:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3erv(value);
        break;
      case 51:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3discountrate(value);
        break;
      case 52:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setL3exityield(value);
        break;
      case 53:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setAcquisition(value);
        break;
      case 54:
        var value = /** @type {string} */ (reader.readString());
        msg.setClientAssetId(value);
        break;
      case 55:
        var value = /** @type {string} */ (reader.readString());
        msg.setProfitCenter(value);
        break;
      case 56:
        var value = /** @type {string} */ (reader.readString());
        msg.setCostCenter(value);
        break;
      case 57:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setMonthlyrent(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.AssetAggregation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.AssetAggregation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.AssetAggregation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.AssetAggregation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPostcode();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPortfolioid();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPortfolioname();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTenantcount();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getOccupancy();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getGlatotal();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getAlertcount();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getLastvaluation();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getNoi();
  if (f !== 0) {
    writer.writeInt32(
      15,
      f
    );
  }
  f = message.getYield();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
  f = message.getAvgrentpersqm();
  if (f !== 0.0) {
    writer.writeDouble(
      17,
      f
    );
  }
  f = message.getGrossyield();
  if (f !== 0.0) {
    writer.writeDouble(
      18,
      f
    );
  }
  f = message.getTotalrent();
  if (f !== 0) {
    writer.writeInt32(
      19,
      f
    );
  }
  f = message.getComment();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getManager();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getL1valuation();
  if (f !== 0.0) {
    writer.writeDouble(
      22,
      f
    );
  }
  f = message.getL1liquidationvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      23,
      f
    );
  }
  f = message.getL1valuer();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getL1dcfmethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      25,
      f
    );
  }
  f = message.getL1comparativemethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      26,
      f
    );
  }
  f = message.getL1insurancemethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      27,
      f
    );
  }
  f = message.getL1currentrent();
  if (f !== 0.0) {
    writer.writeDouble(
      28,
      f
    );
  }
  f = message.getL1erv();
  if (f !== 0.0) {
    writer.writeDouble(
      29,
      f
    );
  }
  f = message.getL1discountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      30,
      f
    );
  }
  f = message.getL1exityield();
  if (f !== 0.0) {
    writer.writeDouble(
      31,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getL2valuation();
  if (f !== 0.0) {
    writer.writeDouble(
      33,
      f
    );
  }
  f = message.getL2liquidationvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      34,
      f
    );
  }
  f = message.getL2valuer();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getL2dcfmethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      36,
      f
    );
  }
  f = message.getL2comparativemethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      37,
      f
    );
  }
  f = message.getL2insurancemethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      38,
      f
    );
  }
  f = message.getL2currentrent();
  if (f !== 0.0) {
    writer.writeDouble(
      39,
      f
    );
  }
  f = message.getL2erv();
  if (f !== 0.0) {
    writer.writeDouble(
      40,
      f
    );
  }
  f = message.getL2discountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      41,
      f
    );
  }
  f = message.getL2exityield();
  if (f !== 0.0) {
    writer.writeDouble(
      42,
      f
    );
  }
  f = message.getL3valuation();
  if (f !== 0.0) {
    writer.writeDouble(
      43,
      f
    );
  }
  f = message.getL3liquidationvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      44,
      f
    );
  }
  f = message.getL3valuer();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getL3dcfmethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      46,
      f
    );
  }
  f = message.getL3comparativemethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      47,
      f
    );
  }
  f = message.getL3insurancemethodvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      48,
      f
    );
  }
  f = message.getL3currentrent();
  if (f !== 0.0) {
    writer.writeDouble(
      49,
      f
    );
  }
  f = message.getL3erv();
  if (f !== 0.0) {
    writer.writeDouble(
      50,
      f
    );
  }
  f = message.getL3discountrate();
  if (f !== 0.0) {
    writer.writeDouble(
      51,
      f
    );
  }
  f = message.getL3exityield();
  if (f !== 0.0) {
    writer.writeDouble(
      52,
      f
    );
  }
  f = message.getAcquisition();
  if (f !== 0.0) {
    writer.writeDouble(
      53,
      f
    );
  }
  f = message.getClientAssetId();
  if (f.length > 0) {
    writer.writeString(
      54,
      f
    );
  }
  f = message.getProfitCenter();
  if (f.length > 0) {
    writer.writeString(
      55,
      f
    );
  }
  f = message.getCostCenter();
  if (f.length > 0) {
    writer.writeString(
      56,
      f
    );
  }
  f = message.getMonthlyrent();
  if (f !== 0) {
    writer.writeInt32(
      57,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string country = 3;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string city = 4;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string street = 5;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string postcode = 6;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getPostcode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setPostcode = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string type = 7;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string portfolioID = 8;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getPortfolioid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setPortfolioid = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string portfolioName = 9;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getPortfolioname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setPortfolioname = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional int32 tenantCount = 10;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getTenantcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setTenantcount = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 occupancy = 11;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setOccupancy = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 glaTotal = 12;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getGlatotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setGlatotal = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 alertCount = 13;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getAlertcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setAlertcount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int32 lastValuation = 14;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getLastvaluation = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setLastvaluation = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int32 NOI = 15;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getNoi = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setNoi = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional double yield = 16;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getYield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setYield = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


/**
 * optional double avgRentPerSQM = 17;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getAvgrentpersqm = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 17, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setAvgrentpersqm = function(value) {
  return jspb.Message.setProto3FloatField(this, 17, value);
};


/**
 * optional double grossYield = 18;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getGrossyield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setGrossyield = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional int32 totalRent = 19;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getTotalrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setTotalrent = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional string comment = 20;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getComment = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setComment = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string manager = 21;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getManager = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setManager = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional double l1Valuation = 22;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1valuation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 22, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1valuation = function(value) {
  return jspb.Message.setProto3FloatField(this, 22, value);
};


/**
 * optional double l1LiquidationValue = 23;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1liquidationvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 23, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1liquidationvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 23, value);
};


/**
 * optional string l1Valuer = 24;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getL1valuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1valuer = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional double l1DcfMethodValue = 25;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1dcfmethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 25, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1dcfmethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 25, value);
};


/**
 * optional double l1ComparativeMethodValue = 26;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1comparativemethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 26, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1comparativemethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 26, value);
};


/**
 * optional double l1InsuranceMethodValue = 27;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1insurancemethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 27, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1insurancemethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 27, value);
};


/**
 * optional double l1CurrentRent = 28;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1currentrent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 28, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1currentrent = function(value) {
  return jspb.Message.setProto3FloatField(this, 28, value);
};


/**
 * optional double l1Erv = 29;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1erv = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 29, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1erv = function(value) {
  return jspb.Message.setProto3FloatField(this, 29, value);
};


/**
 * optional double l1DiscountRate = 30;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1discountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 30, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1discountrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 30, value);
};


/**
 * optional double l1ExitYield = 31;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL1exityield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 31, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL1exityield = function(value) {
  return jspb.Message.setProto3FloatField(this, 31, value);
};


/**
 * optional string status = 32;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional double l2Valuation = 33;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2valuation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 33, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2valuation = function(value) {
  return jspb.Message.setProto3FloatField(this, 33, value);
};


/**
 * optional double l2LiquidationValue = 34;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2liquidationvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 34, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2liquidationvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 34, value);
};


/**
 * optional string l2Valuer = 35;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getL2valuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2valuer = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional double l2DcfMethodValue = 36;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2dcfmethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 36, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2dcfmethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 36, value);
};


/**
 * optional double l2ComparativeMethodValue = 37;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2comparativemethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 37, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2comparativemethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 37, value);
};


/**
 * optional double l2InsuranceMethodValue = 38;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2insurancemethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 38, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2insurancemethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 38, value);
};


/**
 * optional double l2CurrentRent = 39;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2currentrent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 39, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2currentrent = function(value) {
  return jspb.Message.setProto3FloatField(this, 39, value);
};


/**
 * optional double l2Erv = 40;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2erv = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 40, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2erv = function(value) {
  return jspb.Message.setProto3FloatField(this, 40, value);
};


/**
 * optional double l2DiscountRate = 41;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2discountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 41, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2discountrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 41, value);
};


/**
 * optional double l2ExitYield = 42;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL2exityield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 42, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL2exityield = function(value) {
  return jspb.Message.setProto3FloatField(this, 42, value);
};


/**
 * optional double l3Valuation = 43;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3valuation = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 43, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3valuation = function(value) {
  return jspb.Message.setProto3FloatField(this, 43, value);
};


/**
 * optional double l3LiquidationValue = 44;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3liquidationvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 44, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3liquidationvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 44, value);
};


/**
 * optional string l3Valuer = 45;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getL3valuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3valuer = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional double l3DcfMethodValue = 46;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3dcfmethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 46, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3dcfmethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 46, value);
};


/**
 * optional double l3ComparativeMethodValue = 47;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3comparativemethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 47, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3comparativemethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 47, value);
};


/**
 * optional double l3InsuranceMethodValue = 48;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3insurancemethodvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 48, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3insurancemethodvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 48, value);
};


/**
 * optional double l3CurrentRent = 49;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3currentrent = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 49, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3currentrent = function(value) {
  return jspb.Message.setProto3FloatField(this, 49, value);
};


/**
 * optional double l3Erv = 50;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3erv = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 50, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3erv = function(value) {
  return jspb.Message.setProto3FloatField(this, 50, value);
};


/**
 * optional double l3DiscountRate = 51;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3discountrate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 51, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3discountrate = function(value) {
  return jspb.Message.setProto3FloatField(this, 51, value);
};


/**
 * optional double l3ExitYield = 52;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getL3exityield = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 52, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setL3exityield = function(value) {
  return jspb.Message.setProto3FloatField(this, 52, value);
};


/**
 * optional double acquisition = 53;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getAcquisition = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 53, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setAcquisition = function(value) {
  return jspb.Message.setProto3FloatField(this, 53, value);
};


/**
 * optional string client_asset_id = 54;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getClientAssetId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 54, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setClientAssetId = function(value) {
  return jspb.Message.setProto3StringField(this, 54, value);
};


/**
 * optional string profit_center = 55;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getProfitCenter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 55, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setProfitCenter = function(value) {
  return jspb.Message.setProto3StringField(this, 55, value);
};


/**
 * optional string cost_center = 56;
 * @return {string}
 */
proto.external.AssetAggregation.prototype.getCostCenter = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setCostCenter = function(value) {
  return jspb.Message.setProto3StringField(this, 56, value);
};


/**
 * optional int32 monthlyRent = 57;
 * @return {number}
 */
proto.external.AssetAggregation.prototype.getMonthlyrent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 57, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.AssetAggregation} returns this
 */
proto.external.AssetAggregation.prototype.setMonthlyrent = function(value) {
  return jspb.Message.setProto3IntField(this, 57, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.PortfoliosAggregationResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.PortfoliosAggregationResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.PortfoliosAggregationResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.PortfoliosAggregationResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.PortfoliosAggregationResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      portfoliosList: jspb.Message.toObjectList(msg.getPortfoliosList(),
        proto.external.PortfolioAggregation.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.PortfoliosAggregationResponse}
 */
proto.external.PortfoliosAggregationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.PortfoliosAggregationResponse;
  return proto.external.PortfoliosAggregationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.PortfoliosAggregationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.PortfoliosAggregationResponse}
 */
proto.external.PortfoliosAggregationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.external.PortfolioAggregation;
        reader.readMessage(value,proto.external.PortfolioAggregation.deserializeBinaryFromReader);
        msg.addPortfolios(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.PortfoliosAggregationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.PortfoliosAggregationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.PortfoliosAggregationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.PortfoliosAggregationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortfoliosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.external.PortfolioAggregation.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PortfolioAggregation portfolios = 1;
 * @return {!Array<!proto.external.PortfolioAggregation>}
 */
proto.external.PortfoliosAggregationResponse.prototype.getPortfoliosList = function() {
  return /** @type{!Array<!proto.external.PortfolioAggregation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.external.PortfolioAggregation, 1));
};


/**
 * @param {!Array<!proto.external.PortfolioAggregation>} value
 * @return {!proto.external.PortfoliosAggregationResponse} returns this
 */
proto.external.PortfoliosAggregationResponse.prototype.setPortfoliosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.external.PortfolioAggregation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.external.PortfolioAggregation}
 */
proto.external.PortfoliosAggregationResponse.prototype.addPortfolios = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.external.PortfolioAggregation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.PortfoliosAggregationResponse} returns this
 */
proto.external.PortfoliosAggregationResponse.prototype.clearPortfoliosList = function() {
  return this.setPortfoliosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.PortfolioAggregation.prototype.toObject = function(opt_includeInstance) {
    return proto.external.PortfolioAggregation.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.PortfolioAggregation} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.PortfolioAggregation.toObject = function(includeInstance, msg) {
    var f, obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      name: jspb.Message.getFieldWithDefault(msg, 2, ""),
      organizationid: jspb.Message.getFieldWithDefault(msg, 3, ""),
      assetcount: jspb.Message.getFieldWithDefault(msg, 4, 0),
      glatotal: jspb.Message.getFieldWithDefault(msg, 5, 0),
      alertcount: jspb.Message.getFieldWithDefault(msg, 6, 0),
      assigned: jspb.Message.getBooleanFieldWithDefault(msg, 7, false)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.PortfolioAggregation}
 */
proto.external.PortfolioAggregation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.PortfolioAggregation;
  return proto.external.PortfolioAggregation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.PortfolioAggregation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.PortfolioAggregation}
 */
proto.external.PortfolioAggregation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setName(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setOrganizationid(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setAssetcount(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setGlatotal(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setAlertcount(value);
        break;
      case 7:
        var value = /** @type {boolean} */ (reader.readBool());
        msg.setAssigned(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.PortfolioAggregation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.PortfolioAggregation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.PortfolioAggregation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.PortfolioAggregation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOrganizationid();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssetcount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getGlatotal();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAlertcount();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getAssigned();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.external.PortfolioAggregation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.PortfolioAggregation} returns this
 */
proto.external.PortfolioAggregation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.external.PortfolioAggregation.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.PortfolioAggregation} returns this
 */
proto.external.PortfolioAggregation.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string organizationId = 3;
 * @return {string}
 */
proto.external.PortfolioAggregation.prototype.getOrganizationid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.PortfolioAggregation} returns this
 */
proto.external.PortfolioAggregation.prototype.setOrganizationid = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 assetCount = 4;
 * @return {number}
 */
proto.external.PortfolioAggregation.prototype.getAssetcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.PortfolioAggregation} returns this
 */
proto.external.PortfolioAggregation.prototype.setAssetcount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 glaTotal = 5;
 * @return {number}
 */
proto.external.PortfolioAggregation.prototype.getGlatotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.PortfolioAggregation} returns this
 */
proto.external.PortfolioAggregation.prototype.setGlatotal = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 alertCount = 6;
 * @return {number}
 */
proto.external.PortfolioAggregation.prototype.getAlertcount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.PortfolioAggregation} returns this
 */
proto.external.PortfolioAggregation.prototype.setAlertcount = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional bool assigned = 7;
 * @return {boolean}
 */
proto.external.PortfolioAggregation.prototype.getAssigned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.external.PortfolioAggregation} returns this
 */
proto.external.PortfolioAggregation.prototype.setAssigned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetTotalsByTypesRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTotalsByTypesRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTotalsByTypesRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTotalsByTypesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTotalsByTypesRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      portfolioidsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
      assetidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTotalsByTypesRequest}
 */
proto.external.GetTotalsByTypesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTotalsByTypesRequest;
  return proto.external.GetTotalsByTypesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTotalsByTypesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTotalsByTypesRequest}
 */
proto.external.GetTotalsByTypesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.addPortfolioids(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.addAssetids(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTotalsByTypesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTotalsByTypesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTotalsByTypesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTotalsByTypesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortfolioidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getAssetidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string portfolioIDs = 1;
 * @return {!Array<string>}
 */
proto.external.GetTotalsByTypesRequest.prototype.getPortfolioidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetTotalsByTypesRequest} returns this
 */
proto.external.GetTotalsByTypesRequest.prototype.setPortfolioidsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetTotalsByTypesRequest} returns this
 */
proto.external.GetTotalsByTypesRequest.prototype.addPortfolioids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTotalsByTypesRequest} returns this
 */
proto.external.GetTotalsByTypesRequest.prototype.clearPortfolioidsList = function() {
  return this.setPortfolioidsList([]);
};


/**
 * repeated string assetIDs = 2;
 * @return {!Array<string>}
 */
proto.external.GetTotalsByTypesRequest.prototype.getAssetidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetTotalsByTypesRequest} returns this
 */
proto.external.GetTotalsByTypesRequest.prototype.setAssetidsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetTotalsByTypesRequest} returns this
 */
proto.external.GetTotalsByTypesRequest.prototype.addAssetids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTotalsByTypesRequest} returns this
 */
proto.external.GetTotalsByTypesRequest.prototype.clearAssetidsList = function() {
  return this.setAssetidsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTotalsByTypesResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTotalsByTypesResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTotalsByTypesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTotalsByTypesResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      portfolioCount: jspb.Message.getFieldWithDefault(msg, 1, 0),
      assetCount: jspb.Message.getFieldWithDefault(msg, 2, 0),
      tenantCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
      unitsCount: jspb.Message.getFieldWithDefault(msg, 4, 0),
      gla: jspb.Message.getFieldWithDefault(msg, 5, 0),
      occupancy: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
      grossAssetValue: jspb.Message.getFieldWithDefault(msg, 7, 0),
      annualizedIncome: jspb.Message.getFieldWithDefault(msg, 8, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTotalsByTypesResponse}
 */
proto.external.GetTotalsByTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTotalsByTypesResponse;
  return proto.external.GetTotalsByTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTotalsByTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTotalsByTypesResponse}
 */
proto.external.GetTotalsByTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setPortfolioCount(value);
        break;
      case 2:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setAssetCount(value);
        break;
      case 3:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setTenantCount(value);
        break;
      case 4:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setUnitsCount(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setGla(value);
        break;
      case 6:
        var value = /** @type {number} */ (reader.readFloat());
        msg.setOccupancy(value);
        break;
      case 7:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setGrossAssetValue(value);
        break;
      case 8:
        var value = /** @type {number} */ (reader.readInt64());
        msg.setAnnualizedIncome(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTotalsByTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTotalsByTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTotalsByTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTotalsByTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortfolioCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getAssetCount();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTenantCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getUnitsCount();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getGla();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getOccupancy();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
  f = message.getGrossAssetValue();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAnnualizedIncome();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional int32 portfolio_count = 1;
 * @return {number}
 */
proto.external.GetTotalsByTypesResponse.prototype.getPortfolioCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTotalsByTypesResponse} returns this
 */
proto.external.GetTotalsByTypesResponse.prototype.setPortfolioCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 asset_count = 2;
 * @return {number}
 */
proto.external.GetTotalsByTypesResponse.prototype.getAssetCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTotalsByTypesResponse} returns this
 */
proto.external.GetTotalsByTypesResponse.prototype.setAssetCount = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 tenant_count = 3;
 * @return {number}
 */
proto.external.GetTotalsByTypesResponse.prototype.getTenantCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTotalsByTypesResponse} returns this
 */
proto.external.GetTotalsByTypesResponse.prototype.setTenantCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 units_count = 4;
 * @return {number}
 */
proto.external.GetTotalsByTypesResponse.prototype.getUnitsCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTotalsByTypesResponse} returns this
 */
proto.external.GetTotalsByTypesResponse.prototype.setUnitsCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 gla = 5;
 * @return {number}
 */
proto.external.GetTotalsByTypesResponse.prototype.getGla = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTotalsByTypesResponse} returns this
 */
proto.external.GetTotalsByTypesResponse.prototype.setGla = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional float occupancy = 6;
 * @return {number}
 */
proto.external.GetTotalsByTypesResponse.prototype.getOccupancy = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTotalsByTypesResponse} returns this
 */
proto.external.GetTotalsByTypesResponse.prototype.setOccupancy = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional int64 gross_asset_value = 7;
 * @return {number}
 */
proto.external.GetTotalsByTypesResponse.prototype.getGrossAssetValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTotalsByTypesResponse} returns this
 */
proto.external.GetTotalsByTypesResponse.prototype.setGrossAssetValue = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 annualized_income = 8;
 * @return {number}
 */
proto.external.GetTotalsByTypesResponse.prototype.getAnnualizedIncome = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.GetTotalsByTypesResponse} returns this
 */
proto.external.GetTotalsByTypesResponse.prototype.setAnnualizedIncome = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetAssetManagersRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetAssetManagersRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetAssetManagersRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetAssetManagersRequest.toObject = function(includeInstance, msg) {
    var f, obj = {

    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetAssetManagersRequest}
 */
proto.external.GetAssetManagersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetAssetManagersRequest;
  return proto.external.GetAssetManagersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetAssetManagersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetAssetManagersRequest}
 */
proto.external.GetAssetManagersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetAssetManagersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetAssetManagersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetAssetManagersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetAssetManagersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.AssetManagersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.AssetManagersResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.AssetManagersResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.AssetManagersResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.AssetManagersResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      managersList: jspb.Message.toObjectList(msg.getManagersList(),
        proto.external.AssetManagerResponse.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.AssetManagersResponse}
 */
proto.external.AssetManagersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.AssetManagersResponse;
  return proto.external.AssetManagersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.AssetManagersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.AssetManagersResponse}
 */
proto.external.AssetManagersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.external.AssetManagerResponse;
        reader.readMessage(value,proto.external.AssetManagerResponse.deserializeBinaryFromReader);
        msg.addManagers(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.AssetManagersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.AssetManagersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.AssetManagersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.AssetManagersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManagersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.external.AssetManagerResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AssetManagerResponse managers = 1;
 * @return {!Array<!proto.external.AssetManagerResponse>}
 */
proto.external.AssetManagersResponse.prototype.getManagersList = function() {
  return /** @type{!Array<!proto.external.AssetManagerResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.external.AssetManagerResponse, 1));
};


/**
 * @param {!Array<!proto.external.AssetManagerResponse>} value
 * @return {!proto.external.AssetManagersResponse} returns this
 */
proto.external.AssetManagersResponse.prototype.setManagersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.external.AssetManagerResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.external.AssetManagerResponse}
 */
proto.external.AssetManagersResponse.prototype.addManagers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.external.AssetManagerResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.AssetManagersResponse} returns this
 */
proto.external.AssetManagersResponse.prototype.clearManagersList = function() {
  return this.setManagersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.AssetManagerResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.AssetManagerResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.AssetManagerResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.AssetManagerResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.AssetManagerResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      manager: jspb.Message.getFieldWithDefault(msg, 1, ""),
      assetidsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.AssetManagerResponse}
 */
proto.external.AssetManagerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.AssetManagerResponse;
  return proto.external.AssetManagerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.AssetManagerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.AssetManagerResponse}
 */
proto.external.AssetManagerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setManager(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.addAssetids(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.AssetManagerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.AssetManagerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.AssetManagerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.AssetManagerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getManager();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAssetidsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string manager = 1;
 * @return {string}
 */
proto.external.AssetManagerResponse.prototype.getManager = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.AssetManagerResponse} returns this
 */
proto.external.AssetManagerResponse.prototype.setManager = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string assetIDs = 2;
 * @return {!Array<string>}
 */
proto.external.AssetManagerResponse.prototype.getAssetidsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.AssetManagerResponse} returns this
 */
proto.external.AssetManagerResponse.prototype.setAssetidsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.AssetManagerResponse} returns this
 */
proto.external.AssetManagerResponse.prototype.addAssetids = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.AssetManagerResponse} returns this
 */
proto.external.AssetManagerResponse.prototype.clearAssetidsList = function() {
  return this.setAssetidsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetTenantsInvoicesRequest.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTenantsInvoicesRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTenantsInvoicesRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTenantsInvoicesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTenantsInvoicesRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      portfoliosList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
      assetsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTenantsInvoicesRequest}
 */
proto.external.GetTenantsInvoicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTenantsInvoicesRequest;
  return proto.external.GetTenantsInvoicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTenantsInvoicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTenantsInvoicesRequest}
 */
proto.external.GetTenantsInvoicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.addPortfolios(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.addAssets(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTenantsInvoicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTenantsInvoicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTenantsInvoicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTenantsInvoicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPortfoliosList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getAssetsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * repeated string portfolios = 1;
 * @return {!Array<string>}
 */
proto.external.GetTenantsInvoicesRequest.prototype.getPortfoliosList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetTenantsInvoicesRequest} returns this
 */
proto.external.GetTenantsInvoicesRequest.prototype.setPortfoliosList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetTenantsInvoicesRequest} returns this
 */
proto.external.GetTenantsInvoicesRequest.prototype.addPortfolios = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantsInvoicesRequest} returns this
 */
proto.external.GetTenantsInvoicesRequest.prototype.clearPortfoliosList = function() {
  return this.setPortfoliosList([]);
};


/**
 * repeated string assets = 2;
 * @return {!Array<string>}
 */
proto.external.GetTenantsInvoicesRequest.prototype.getAssetsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetTenantsInvoicesRequest} returns this
 */
proto.external.GetTenantsInvoicesRequest.prototype.setAssetsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetTenantsInvoicesRequest} returns this
 */
proto.external.GetTenantsInvoicesRequest.prototype.addAssets = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantsInvoicesRequest} returns this
 */
proto.external.GetTenantsInvoicesRequest.prototype.clearAssetsList = function() {
  return this.setAssetsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetTenantsInvoicesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTenantsInvoicesResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTenantsInvoicesResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTenantsInvoicesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTenantsInvoicesResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantsList: jspb.Message.toObjectList(msg.getTenantsList(),
        proto.external.TenantInvoiceResponse.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTenantsInvoicesResponse}
 */
proto.external.GetTenantsInvoicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTenantsInvoicesResponse;
  return proto.external.GetTenantsInvoicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTenantsInvoicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTenantsInvoicesResponse}
 */
proto.external.GetTenantsInvoicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.external.TenantInvoiceResponse;
        reader.readMessage(value,proto.external.TenantInvoiceResponse.deserializeBinaryFromReader);
        msg.addTenants(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTenantsInvoicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTenantsInvoicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTenantsInvoicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTenantsInvoicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.external.TenantInvoiceResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TenantInvoiceResponse tenants = 1;
 * @return {!Array<!proto.external.TenantInvoiceResponse>}
 */
proto.external.GetTenantsInvoicesResponse.prototype.getTenantsList = function() {
  return /** @type{!Array<!proto.external.TenantInvoiceResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.external.TenantInvoiceResponse, 1));
};


/**
 * @param {!Array<!proto.external.TenantInvoiceResponse>} value
 * @return {!proto.external.GetTenantsInvoicesResponse} returns this
 */
proto.external.GetTenantsInvoicesResponse.prototype.setTenantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.external.TenantInvoiceResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.external.TenantInvoiceResponse}
 */
proto.external.GetTenantsInvoicesResponse.prototype.addTenants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.external.TenantInvoiceResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantsInvoicesResponse} returns this
 */
proto.external.GetTenantsInvoicesResponse.prototype.clearTenantsList = function() {
  return this.setTenantsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.TenantInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.TenantInvoiceResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.TenantInvoiceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.TenantInvoiceResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      companyname: jspb.Message.getFieldWithDefault(msg, 2, ""),
      tradingname: jspb.Message.getFieldWithDefault(msg, 3, ""),
      assetname: jspb.Message.getFieldWithDefault(msg, 4, ""),
      mainContact: jspb.Message.getFieldWithDefault(msg, 5, ""),
      portfolioname: jspb.Message.getFieldWithDefault(msg, 6, ""),
      nextinvoiceperiodstartdate: jspb.Message.getFieldWithDefault(msg, 7, ""),
      nextinvoiceperiodenddate: jspb.Message.getFieldWithDefault(msg, 8, ""),
      nextinvoicedate: jspb.Message.getFieldWithDefault(msg, 9, ""),
      nextinvoicepaymentvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
      nextinvoicestatus: jspb.Message.getFieldWithDefault(msg, 11, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.TenantInvoiceResponse}
 */
proto.external.TenantInvoiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.TenantInvoiceResponse;
  return proto.external.TenantInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.TenantInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.TenantInvoiceResponse}
 */
proto.external.TenantInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyname(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setTradingname(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setAssetname(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setMainContact(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setPortfolioname(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setNextinvoiceperiodstartdate(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setNextinvoiceperiodenddate(value);
        break;
      case 9:
        var value = /** @type {string} */ (reader.readString());
        msg.setNextinvoicedate(value);
        break;
      case 10:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setNextinvoicepaymentvalue(value);
        break;
      case 11:
        var value = /** @type {string} */ (reader.readString());
        msg.setNextinvoicestatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.TenantInvoiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.TenantInvoiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.TenantInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.TenantInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCompanyname();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTradingname();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAssetname();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMainContact();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPortfolioname();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNextinvoiceperiodstartdate();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNextinvoiceperiodenddate();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNextinvoicedate();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNextinvoicepaymentvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getNextinvoicestatus();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string companyName = 2;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getCompanyname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setCompanyname = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string tradingName = 3;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getTradingname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setTradingname = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string assetName = 4;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getAssetname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setAssetname = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string main_contact = 5;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getMainContact = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setMainContact = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string portfolioName = 6;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getPortfolioname = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setPortfolioname = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string nextInvoicePeriodStartDate = 7;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getNextinvoiceperiodstartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setNextinvoiceperiodstartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string nextInvoicePeriodEndDate = 8;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getNextinvoiceperiodenddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setNextinvoiceperiodenddate = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string nextInvoiceDate = 9;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getNextinvoicedate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setNextinvoicedate = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional double nextInvoicePaymentValue = 10;
 * @return {number}
 */
proto.external.TenantInvoiceResponse.prototype.getNextinvoicepaymentvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setNextinvoicepaymentvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional string nextInvoiceStatus = 11;
 * @return {string}
 */
proto.external.TenantInvoiceResponse.prototype.getNextinvoicestatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.TenantInvoiceResponse} returns this
 */
proto.external.TenantInvoiceResponse.prototype.setNextinvoicestatus = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTenantInvoicesRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTenantInvoicesRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTenantInvoicesRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTenantInvoicesRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantid: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTenantInvoicesRequest}
 */
proto.external.GetTenantInvoicesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTenantInvoicesRequest;
  return proto.external.GetTenantInvoicesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTenantInvoicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTenantInvoicesRequest}
 */
proto.external.GetTenantInvoicesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTenantid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTenantInvoicesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTenantInvoicesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTenantInvoicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTenantInvoicesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tenantId = 1;
 * @return {string}
 */
proto.external.GetTenantInvoicesRequest.prototype.getTenantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetTenantInvoicesRequest} returns this
 */
proto.external.GetTenantInvoicesRequest.prototype.setTenantid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetTenantInvoicesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetTenantInvoicesResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetTenantInvoicesResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetTenantInvoicesResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetTenantInvoicesResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantsList: jspb.Message.toObjectList(msg.getTenantsList(),
        proto.external.InvoiceDetailsResponse.toObject, includeInstance)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetTenantInvoicesResponse}
 */
proto.external.GetTenantInvoicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetTenantInvoicesResponse;
  return proto.external.GetTenantInvoicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetTenantInvoicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetTenantInvoicesResponse}
 */
proto.external.GetTenantInvoicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.external.InvoiceDetailsResponse;
        reader.readMessage(value,proto.external.InvoiceDetailsResponse.deserializeBinaryFromReader);
        msg.addTenants(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetTenantInvoicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetTenantInvoicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetTenantInvoicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetTenantInvoicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.external.InvoiceDetailsResponse.serializeBinaryToWriter
    );
  }
};


/**
 * repeated InvoiceDetailsResponse tenants = 1;
 * @return {!Array<!proto.external.InvoiceDetailsResponse>}
 */
proto.external.GetTenantInvoicesResponse.prototype.getTenantsList = function() {
  return /** @type{!Array<!proto.external.InvoiceDetailsResponse>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.external.InvoiceDetailsResponse, 1));
};


/**
 * @param {!Array<!proto.external.InvoiceDetailsResponse>} value
 * @return {!proto.external.GetTenantInvoicesResponse} returns this
 */
proto.external.GetTenantInvoicesResponse.prototype.setTenantsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.external.InvoiceDetailsResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.external.InvoiceDetailsResponse}
 */
proto.external.GetTenantInvoicesResponse.prototype.addTenants = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.external.InvoiceDetailsResponse, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetTenantInvoicesResponse} returns this
 */
proto.external.GetTenantInvoicesResponse.prototype.clearTenantsList = function() {
  return this.setTenantsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.InvoiceDetailsResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.InvoiceDetailsResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.InvoiceDetailsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.InvoiceDetailsResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      periodstartdate: jspb.Message.getFieldWithDefault(msg, 2, ""),
      periodenddate: jspb.Message.getFieldWithDefault(msg, 3, ""),
      invoicedate: jspb.Message.getFieldWithDefault(msg, 4, ""),
      invoicepaymentvalue: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
      status: jspb.Message.getFieldWithDefault(msg, 6, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.InvoiceDetailsResponse}
 */
proto.external.InvoiceDetailsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.InvoiceDetailsResponse;
  return proto.external.InvoiceDetailsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.InvoiceDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.InvoiceDetailsResponse}
 */
proto.external.InvoiceDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setPeriodstartdate(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setPeriodenddate(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setInvoicedate(value);
        break;
      case 5:
        var value = /** @type {number} */ (reader.readDouble());
        msg.setInvoicepaymentvalue(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setStatus(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.InvoiceDetailsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.InvoiceDetailsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.InvoiceDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.InvoiceDetailsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPeriodstartdate();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPeriodenddate();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getInvoicedate();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getInvoicepaymentvalue();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.external.InvoiceDetailsResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceDetailsResponse} returns this
 */
proto.external.InvoiceDetailsResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string periodStartDate = 2;
 * @return {string}
 */
proto.external.InvoiceDetailsResponse.prototype.getPeriodstartdate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceDetailsResponse} returns this
 */
proto.external.InvoiceDetailsResponse.prototype.setPeriodstartdate = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string periodEndDate = 3;
 * @return {string}
 */
proto.external.InvoiceDetailsResponse.prototype.getPeriodenddate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceDetailsResponse} returns this
 */
proto.external.InvoiceDetailsResponse.prototype.setPeriodenddate = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string invoiceDate = 4;
 * @return {string}
 */
proto.external.InvoiceDetailsResponse.prototype.getInvoicedate = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceDetailsResponse} returns this
 */
proto.external.InvoiceDetailsResponse.prototype.setInvoicedate = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional double invoicePaymentValue = 5;
 * @return {number}
 */
proto.external.InvoiceDetailsResponse.prototype.getInvoicepaymentvalue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.external.InvoiceDetailsResponse} returns this
 */
proto.external.InvoiceDetailsResponse.prototype.setInvoicepaymentvalue = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.external.InvoiceDetailsResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceDetailsResponse} returns this
 */
proto.external.InvoiceDetailsResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.ExecuteInvoiceActionRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.ExecuteInvoiceActionRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.ExecuteInvoiceActionRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.ExecuteInvoiceActionRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, ""),
      action: jspb.Message.getFieldWithDefault(msg, 2, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.ExecuteInvoiceActionRequest}
 */
proto.external.ExecuteInvoiceActionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.ExecuteInvoiceActionRequest;
  return proto.external.ExecuteInvoiceActionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.ExecuteInvoiceActionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.ExecuteInvoiceActionRequest}
 */
proto.external.ExecuteInvoiceActionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      case 2:
        var value = /** @type {!proto.external.InvoiceAction} */ (reader.readEnum());
        msg.setAction(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.ExecuteInvoiceActionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.ExecuteInvoiceActionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.ExecuteInvoiceActionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.ExecuteInvoiceActionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.external.ExecuteInvoiceActionRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.ExecuteInvoiceActionRequest} returns this
 */
proto.external.ExecuteInvoiceActionRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InvoiceAction action = 2;
 * @return {!proto.external.InvoiceAction}
 */
proto.external.ExecuteInvoiceActionRequest.prototype.getAction = function() {
  return /** @type {!proto.external.InvoiceAction} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.external.InvoiceAction} value
 * @return {!proto.external.ExecuteInvoiceActionRequest} returns this
 */
proto.external.ExecuteInvoiceActionRequest.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.ExecuteInvoiceActionResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.ExecuteInvoiceActionResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.ExecuteInvoiceActionResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.ExecuteInvoiceActionResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      id: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.ExecuteInvoiceActionResponse}
 */
proto.external.ExecuteInvoiceActionResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.ExecuteInvoiceActionResponse;
  return proto.external.ExecuteInvoiceActionResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.ExecuteInvoiceActionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.ExecuteInvoiceActionResponse}
 */
proto.external.ExecuteInvoiceActionResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.ExecuteInvoiceActionResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.ExecuteInvoiceActionResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.ExecuteInvoiceActionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.ExecuteInvoiceActionResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.external.ExecuteInvoiceActionResponse.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.ExecuteInvoiceActionResponse} returns this
 */
proto.external.ExecuteInvoiceActionResponse.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetRecipientsRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetRecipientsRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetRecipientsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetRecipientsRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantid: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetRecipientsRequest}
 */
proto.external.GetRecipientsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetRecipientsRequest;
  return proto.external.GetRecipientsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetRecipientsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetRecipientsRequest}
 */
proto.external.GetRecipientsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTenantid(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetRecipientsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetRecipientsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetRecipientsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetRecipientsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tenantId = 1;
 * @return {string}
 */
proto.external.GetRecipientsRequest.prototype.getTenantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetRecipientsRequest} returns this
 */
proto.external.GetRecipientsRequest.prototype.setTenantid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.GetRecipientsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetRecipientsResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetRecipientsResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetRecipientsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetRecipientsResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      recipientsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
      primaryrecipient: jspb.Message.getFieldWithDefault(msg, 2, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetRecipientsResponse}
 */
proto.external.GetRecipientsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetRecipientsResponse;
  return proto.external.GetRecipientsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetRecipientsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetRecipientsResponse}
 */
proto.external.GetRecipientsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.addRecipients(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setPrimaryrecipient(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetRecipientsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetRecipientsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetRecipientsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetRecipientsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getPrimaryrecipient();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * repeated string recipients = 1;
 * @return {!Array<string>}
 */
proto.external.GetRecipientsResponse.prototype.getRecipientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.GetRecipientsResponse} returns this
 */
proto.external.GetRecipientsResponse.prototype.setRecipientsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.GetRecipientsResponse} returns this
 */
proto.external.GetRecipientsResponse.prototype.addRecipients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.GetRecipientsResponse} returns this
 */
proto.external.GetRecipientsResponse.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional string primaryRecipient = 2;
 * @return {string}
 */
proto.external.GetRecipientsResponse.prototype.getPrimaryrecipient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.GetRecipientsResponse} returns this
 */
proto.external.GetRecipientsResponse.prototype.setPrimaryrecipient = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.SyncRecipientsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.SyncRecipientsRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.SyncRecipientsRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.SyncRecipientsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.SyncRecipientsRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      tenantid: jspb.Message.getFieldWithDefault(msg, 1, ""),
      recipientsList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
      primaryrecipient: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.SyncRecipientsRequest}
 */
proto.external.SyncRecipientsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.SyncRecipientsRequest;
  return proto.external.SyncRecipientsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.SyncRecipientsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.SyncRecipientsRequest}
 */
proto.external.SyncRecipientsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setTenantid(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.addRecipients(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setPrimaryrecipient(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.SyncRecipientsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.SyncRecipientsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.SyncRecipientsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.SyncRecipientsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTenantid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getPrimaryrecipient();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string tenantId = 1;
 * @return {string}
 */
proto.external.SyncRecipientsRequest.prototype.getTenantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.SyncRecipientsRequest} returns this
 */
proto.external.SyncRecipientsRequest.prototype.setTenantid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string recipients = 2;
 * @return {!Array<string>}
 */
proto.external.SyncRecipientsRequest.prototype.getRecipientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.SyncRecipientsRequest} returns this
 */
proto.external.SyncRecipientsRequest.prototype.setRecipientsList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.SyncRecipientsRequest} returns this
 */
proto.external.SyncRecipientsRequest.prototype.addRecipients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.SyncRecipientsRequest} returns this
 */
proto.external.SyncRecipientsRequest.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};


/**
 * optional string primaryRecipient = 3;
 * @return {string}
 */
proto.external.SyncRecipientsRequest.prototype.getPrimaryrecipient = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.SyncRecipientsRequest} returns this
 */
proto.external.SyncRecipientsRequest.prototype.setPrimaryrecipient = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.external.SyncRecipientsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.SyncRecipientsResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.SyncRecipientsResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.SyncRecipientsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.SyncRecipientsResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      recipientsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.SyncRecipientsResponse}
 */
proto.external.SyncRecipientsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.SyncRecipientsResponse;
  return proto.external.SyncRecipientsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.SyncRecipientsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.SyncRecipientsResponse}
 */
proto.external.SyncRecipientsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.addRecipients(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.SyncRecipientsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.SyncRecipientsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.SyncRecipientsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.SyncRecipientsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRecipientsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string recipients = 1;
 * @return {!Array<string>}
 */
proto.external.SyncRecipientsResponse.prototype.getRecipientsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.external.SyncRecipientsResponse} returns this
 */
proto.external.SyncRecipientsResponse.prototype.setRecipientsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.external.SyncRecipientsResponse} returns this
 */
proto.external.SyncRecipientsResponse.prototype.addRecipients = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.external.SyncRecipientsResponse} returns this
 */
proto.external.SyncRecipientsResponse.prototype.clearRecipientsList = function() {
  return this.setRecipientsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.InvoiceSettings.prototype.toObject = function(opt_includeInstance) {
    return proto.external.InvoiceSettings.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.InvoiceSettings} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.InvoiceSettings.toObject = function(includeInstance, msg) {
    var f, obj = {
      companyName: jspb.Message.getFieldWithDefault(msg, 1, ""),
      invoiceNumberPrefix: jspb.Message.getFieldWithDefault(msg, 2, ""),
      companyAddress: jspb.Message.getFieldWithDefault(msg, 3, ""),
      paymentTerms: jspb.Message.getFieldWithDefault(msg, 4, ""),
      paymentInstructions: jspb.Message.getFieldWithDefault(msg, 5, ""),
      footerNotes: jspb.Message.getFieldWithDefault(msg, 6, ""),
      companyEmail: jspb.Message.getFieldWithDefault(msg, 7, ""),
      companyPhone: jspb.Message.getFieldWithDefault(msg, 8, ""),
      invoiceDateConfiguration: jspb.Message.getFieldWithDefault(msg, 9, 0)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.InvoiceSettings}
 */
proto.external.InvoiceSettings.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.InvoiceSettings;
  return proto.external.InvoiceSettings.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.InvoiceSettings} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.InvoiceSettings}
 */
proto.external.InvoiceSettings.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyName(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setInvoiceNumberPrefix(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyAddress(value);
        break;
      case 4:
        var value = /** @type {string} */ (reader.readString());
        msg.setPaymentTerms(value);
        break;
      case 5:
        var value = /** @type {string} */ (reader.readString());
        msg.setPaymentInstructions(value);
        break;
      case 6:
        var value = /** @type {string} */ (reader.readString());
        msg.setFooterNotes(value);
        break;
      case 7:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyEmail(value);
        break;
      case 8:
        var value = /** @type {string} */ (reader.readString());
        msg.setCompanyPhone(value);
        break;
      case 9:
        var value = /** @type {number} */ (reader.readInt32());
        msg.setInvoiceDateConfiguration(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.InvoiceSettings.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.InvoiceSettings.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.InvoiceSettings} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.InvoiceSettings.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInvoiceNumberPrefix();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCompanyAddress();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPaymentTerms();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPaymentInstructions();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFooterNotes();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCompanyEmail();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCompanyPhone();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getInvoiceDateConfiguration();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
};


/**
 * optional string company_name = 1;
 * @return {string}
 */
proto.external.InvoiceSettings.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string invoice_number_prefix = 2;
 * @return {string}
 */
proto.external.InvoiceSettings.prototype.getInvoiceNumberPrefix = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setInvoiceNumberPrefix = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string company_address = 3;
 * @return {string}
 */
proto.external.InvoiceSettings.prototype.getCompanyAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setCompanyAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string payment_terms = 4;
 * @return {string}
 */
proto.external.InvoiceSettings.prototype.getPaymentTerms = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setPaymentTerms = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string payment_instructions = 5;
 * @return {string}
 */
proto.external.InvoiceSettings.prototype.getPaymentInstructions = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setPaymentInstructions = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string footer_notes = 6;
 * @return {string}
 */
proto.external.InvoiceSettings.prototype.getFooterNotes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setFooterNotes = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string company_email = 7;
 * @return {string}
 */
proto.external.InvoiceSettings.prototype.getCompanyEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setCompanyEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string company_phone = 8;
 * @return {string}
 */
proto.external.InvoiceSettings.prototype.getCompanyPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setCompanyPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional int32 invoice_date_configuration = 9;
 * @return {number}
 */
proto.external.InvoiceSettings.prototype.getInvoiceDateConfiguration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.external.InvoiceSettings} returns this
 */
proto.external.InvoiceSettings.prototype.setInvoiceDateConfiguration = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.SaveInvoiceSettingsRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.SaveInvoiceSettingsRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.SaveInvoiceSettingsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.SaveInvoiceSettingsRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      settings: (f = msg.getSettings()) && proto.external.InvoiceSettings.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.SaveInvoiceSettingsRequest}
 */
proto.external.SaveInvoiceSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.SaveInvoiceSettingsRequest;
  return proto.external.SaveInvoiceSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.SaveInvoiceSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.SaveInvoiceSettingsRequest}
 */
proto.external.SaveInvoiceSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 2:
        var value = new proto.external.InvoiceSettings;
        reader.readMessage(value,proto.external.InvoiceSettings.deserializeBinaryFromReader);
        msg.setSettings(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.SaveInvoiceSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.SaveInvoiceSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.SaveInvoiceSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.SaveInvoiceSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.external.InvoiceSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional InvoiceSettings settings = 2;
 * @return {?proto.external.InvoiceSettings}
 */
proto.external.SaveInvoiceSettingsRequest.prototype.getSettings = function() {
  return /** @type{?proto.external.InvoiceSettings} */ (
    jspb.Message.getWrapperField(this, proto.external.InvoiceSettings, 2));
};


/**
 * @param {?proto.external.InvoiceSettings|undefined} value
 * @return {!proto.external.SaveInvoiceSettingsRequest} returns this
 */
proto.external.SaveInvoiceSettingsRequest.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.external.SaveInvoiceSettingsRequest} returns this
 */
proto.external.SaveInvoiceSettingsRequest.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.external.SaveInvoiceSettingsRequest.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.SaveInvoiceSettingsResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.SaveInvoiceSettingsResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.SaveInvoiceSettingsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.SaveInvoiceSettingsResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      settings: (f = msg.getSettings()) && proto.external.InvoiceSettings.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.SaveInvoiceSettingsResponse}
 */
proto.external.SaveInvoiceSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.SaveInvoiceSettingsResponse;
  return proto.external.SaveInvoiceSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.SaveInvoiceSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.SaveInvoiceSettingsResponse}
 */
proto.external.SaveInvoiceSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.external.InvoiceSettings;
        reader.readMessage(value,proto.external.InvoiceSettings.deserializeBinaryFromReader);
        msg.setSettings(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.SaveInvoiceSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.SaveInvoiceSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.SaveInvoiceSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.SaveInvoiceSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.external.InvoiceSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional InvoiceSettings settings = 1;
 * @return {?proto.external.InvoiceSettings}
 */
proto.external.SaveInvoiceSettingsResponse.prototype.getSettings = function() {
  return /** @type{?proto.external.InvoiceSettings} */ (
    jspb.Message.getWrapperField(this, proto.external.InvoiceSettings, 1));
};


/**
 * @param {?proto.external.InvoiceSettings|undefined} value
 * @return {!proto.external.SaveInvoiceSettingsResponse} returns this
 */
proto.external.SaveInvoiceSettingsResponse.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.external.SaveInvoiceSettingsResponse} returns this
 */
proto.external.SaveInvoiceSettingsResponse.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.external.SaveInvoiceSettingsResponse.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetInvoiceSettingsRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetInvoiceSettingsRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetInvoiceSettingsRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetInvoiceSettingsRequest.toObject = function(includeInstance, msg) {
    var f, obj = {

    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetInvoiceSettingsRequest}
 */
proto.external.GetInvoiceSettingsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetInvoiceSettingsRequest;
  return proto.external.GetInvoiceSettingsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetInvoiceSettingsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetInvoiceSettingsRequest}
 */
proto.external.GetInvoiceSettingsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetInvoiceSettingsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetInvoiceSettingsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetInvoiceSettingsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetInvoiceSettingsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.GetInvoiceSettingsResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.GetInvoiceSettingsResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.GetInvoiceSettingsResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.GetInvoiceSettingsResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      settings: (f = msg.getSettings()) && proto.external.InvoiceSettings.toObject(includeInstance, f)
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.GetInvoiceSettingsResponse}
 */
proto.external.GetInvoiceSettingsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.GetInvoiceSettingsResponse;
  return proto.external.GetInvoiceSettingsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.GetInvoiceSettingsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.GetInvoiceSettingsResponse}
 */
proto.external.GetInvoiceSettingsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = new proto.external.InvoiceSettings;
        reader.readMessage(value,proto.external.InvoiceSettings.deserializeBinaryFromReader);
        msg.setSettings(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.GetInvoiceSettingsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.GetInvoiceSettingsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.GetInvoiceSettingsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.GetInvoiceSettingsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.external.InvoiceSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional InvoiceSettings settings = 1;
 * @return {?proto.external.InvoiceSettings}
 */
proto.external.GetInvoiceSettingsResponse.prototype.getSettings = function() {
  return /** @type{?proto.external.InvoiceSettings} */ (
    jspb.Message.getWrapperField(this, proto.external.InvoiceSettings, 1));
};


/**
 * @param {?proto.external.InvoiceSettings|undefined} value
 * @return {!proto.external.GetInvoiceSettingsResponse} returns this
 */
proto.external.GetInvoiceSettingsResponse.prototype.setSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.external.GetInvoiceSettingsResponse} returns this
 */
proto.external.GetInvoiceSettingsResponse.prototype.clearSettings = function() {
  return this.setSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.external.GetInvoiceSettingsResponse.prototype.hasSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.DownloadInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
    return proto.external.DownloadInvoiceRequest.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.DownloadInvoiceRequest} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.DownloadInvoiceRequest.toObject = function(includeInstance, msg) {
    var f, obj = {
      invoiceId: jspb.Message.getFieldWithDefault(msg, 1, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.DownloadInvoiceRequest}
 */
proto.external.DownloadInvoiceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.DownloadInvoiceRequest;
  return proto.external.DownloadInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.DownloadInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.DownloadInvoiceRequest}
 */
proto.external.DownloadInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {string} */ (reader.readString());
        msg.setInvoiceId(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.DownloadInvoiceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.DownloadInvoiceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.DownloadInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.DownloadInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInvoiceId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string invoice_id = 1;
 * @return {string}
 */
proto.external.DownloadInvoiceRequest.prototype.getInvoiceId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.DownloadInvoiceRequest} returns this
 */
proto.external.DownloadInvoiceRequest.prototype.setInvoiceId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
  /**
   * Creates an object representation of this proto.
   * Field names that are reserved in JavaScript and will be renamed to pb_name.
   * Optional fields that are not set will be set to undefined.
   * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
   * For the list of reserved names please see:
   *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
   * @param {boolean=} opt_includeInstance Deprecated. whether to include the
   *     JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @return {!Object}
   */
  proto.external.DownloadInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
    return proto.external.DownloadInvoiceResponse.toObject(opt_includeInstance, this);
  };


  /**
   * Static version of the {@see toObject} method.
   * @param {boolean|undefined} includeInstance Deprecated. Whether to include
   *     the JSPB instance for transitional soy proto support:
   *     http://goto/soy-param-migration
   * @param {!proto.external.DownloadInvoiceResponse} msg The msg instance to transform.
   * @return {!Object}
   * @suppress {unusedLocalVariables} f is only used for nested messages
   */
  proto.external.DownloadInvoiceResponse.toObject = function(includeInstance, msg) {
    var f, obj = {
      fileContent: msg.getFileContent_asB64(),
      fileName: jspb.Message.getFieldWithDefault(msg, 2, ""),
      contentType: jspb.Message.getFieldWithDefault(msg, 3, "")
    };

    if (includeInstance) {
      obj.$jspbMessageInstance = msg;
    }
    return obj;
  };
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.external.DownloadInvoiceResponse}
 */
proto.external.DownloadInvoiceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.external.DownloadInvoiceResponse;
  return proto.external.DownloadInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.external.DownloadInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.external.DownloadInvoiceResponse}
 */
proto.external.DownloadInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
      case 1:
        var value = /** @type {!Uint8Array} */ (reader.readBytes());
        msg.setFileContent(value);
        break;
      case 2:
        var value = /** @type {string} */ (reader.readString());
        msg.setFileName(value);
        break;
      case 3:
        var value = /** @type {string} */ (reader.readString());
        msg.setContentType(value);
        break;
      default:
        reader.skipField();
        break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.external.DownloadInvoiceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.external.DownloadInvoiceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.external.DownloadInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.external.DownloadInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileContent_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = message.getFileName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional bytes file_content = 1;
 * @return {!(string|Uint8Array)}
 */
proto.external.DownloadInvoiceResponse.prototype.getFileContent = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes file_content = 1;
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {string}
 */
proto.external.DownloadInvoiceResponse.prototype.getFileContent_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
    this.getFileContent()));
};


/**
 * optional bytes file_content = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileContent()`
 * @return {!Uint8Array}
 */
proto.external.DownloadInvoiceResponse.prototype.getFileContent_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
    this.getFileContent()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.external.DownloadInvoiceResponse} returns this
 */
proto.external.DownloadInvoiceResponse.prototype.setFileContent = function(value) {
  return jspb.Message.setProto3BytesField(this, 1, value);
};


/**
 * optional string file_name = 2;
 * @return {string}
 */
proto.external.DownloadInvoiceResponse.prototype.getFileName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.DownloadInvoiceResponse} returns this
 */
proto.external.DownloadInvoiceResponse.prototype.setFileName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string content_type = 3;
 * @return {string}
 */
proto.external.DownloadInvoiceResponse.prototype.getContentType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.external.DownloadInvoiceResponse} returns this
 */
proto.external.DownloadInvoiceResponse.prototype.setContentType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.external.InvoiceAction = {
  APPROVE: 0,
  SEND: 1,
  PAID: 2
};

goog.object.extend(exports, proto.external);